import React from 'react';
import {StyleSheet, View} from 'react-native';
import RoundedButton, {ButtonType} from '../../elements/RoundedButton';
import Localized from '../../../constants/AppStrings';
import Styles from '../../Styles';
import RevolveSearchIconSvg from '../../img/svg/RevolveSearchIconSvg';
import AVText from '../../elements/AVText';
import AVFormattedCurrency from '../../elements/AVFormattedCurrency';
import AccountStore from '../../../stores/AccountStore';
import {useAppSelector} from '../../../redux/hooks';
import {getTotalAvailableBalance} from '../../../Util';
import {scanAndPayTemplate} from 'src/components/screens/scanAndPay/templates/scanandPayThemeHelper';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import BalanceAmount from 'src/components/screens/scanAndPay/BalanceAmount';

const {
  shadowStyles,
  bodyLargeFontSize,
  mainFontFamily,
  bodySmallFontSize,
  subHeaderFontSize,
} = getLayoutDescriber();

const shadowOverrides = scanAndPayTemplate.showCategoriesShadow
  ? shadowStyles().shadow
  : {};

function SearchAndBalanceAmount({onPress}: {onPress: () => void}) {
  const balances = useAppSelector((state) => state.account.account.balances);
  const balance = {
    balance: getTotalAvailableBalance(balances),
    currency: AccountStore.getCurrency(),
  };

  return (
    <View style={styles.searchWrapper}>
      <View style={styles.shadow}>
        <RoundedButton
          accessible={true}
          accessibilityLabel={Localized.Labels.searchproducts}
          accessibilityRole="button"
          aria-label={Localized.Labels.searchproducts}
          role="button"
          containerStyle={styles.btnEmptyCartSearch}
          buttonType={ButtonType.normalWhite}
          onPress={onPress}
          backgroundColor={Styles.white}
          text={Localized.Labels.searchproducts}
          textStyle={styles.searchBtnText}
          icon={
            <RevolveSearchIconSvg color={scanAndPayTemplate.searchIconColor} />
          }
          isProductSearch={true}
          color={Styles.Colors.PayNew.neutralHuesBase09}
        />
      </View>

      <BalanceAmount></BalanceAmount>
    </View>
  );
}

const styles = StyleSheet.create({
  balanceAmountText: {
    fontFamily: mainFontFamily(),
    fontSize: bodySmallFontSize(),
  },
  amountText: {
    fontFamily: mainFontFamily(),
    fontSize: subHeaderFontSize(),
    fontWeight: 'bold',
  },
  balanceContainer: {
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginLeft: Styles.Spacing.m3,
  },
  searchWrapper: {
    marginTop: Styles.Spacing.m3,
    marginHorizontal: Styles.Spacing.m3,
    flexDirection: 'row',
  },
  searchBtnText: {
    fontSize: bodyLargeFontSize(),
    fontWeight: '400',
    fontFamily: mainFontFamily(),
    color: Styles.Colors.PayNew.darkHuesBase04,
  },
  shadow: {
    flex: 1,
    borderRadius: 40,
    ...shadowOverrides,
  },
  btnEmptyCartSearch: {
    width: '100%',
    borderWidth: 1,
    borderTopColor: '#C2C2C5',
    borderBottomColor: '#C2C2C5',
    borderStartColor: '#C2C2C5',
    borderEndColor: '#C2C2C5',
    backgroundColor: Styles.white,
  },
});

export default SearchAndBalanceAmount;
